import { Navigate } from 'react-router-dom';

import ExplanationTemplate from '../ExplanationTemplate/ExplanationTemplate'
import InfographicTemplate from '../InfographicTemplate/InfographicTemplate'
import ChecklistTemplate from '../ChecklistTemplate/ChecklistTemplate'

function RenderPartsInTemplates({ selectedPart }) {
  if (!selectedPart) {
    return <Navigate to="/learn" />;
  }

  switch (selectedPart.template) {
    case 'explanation':
      return <ExplanationTemplate selectedPart={selectedPart} />;
    case 'infographic':
      return <InfographicTemplate selectedPart={selectedPart} />;
    case 'checklist':
      return <ChecklistTemplate selectedPart={selectedPart} />;
    default:
      return <div>Unknown part type</div>;
  }
}

export default RenderPartsInTemplates